var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1924_6861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37V37H0V0Z",
    fill: "url(#paint0_linear_1924_6861)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1924_6861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.476 11.2339H25.227C25.4362 11.2286 25.6443 11.2653 25.8391 11.3417C26.0339 11.418 26.2114 11.5327 26.3612 11.6787C26.511 11.8248 26.6301 11.9994 26.7114 12.1922C26.7927 12.385 26.8346 12.5922 26.8346 12.8014C26.8346 13.0106 26.7927 13.2178 26.7114 13.4106C26.6301 13.6034 26.511 13.778 26.3612 13.9241C26.2114 14.0701 26.0339 14.1847 25.8391 14.2611C25.6443 14.3375 25.4362 14.3742 25.227 14.3689H24.783L23.601 26.2469C23.5543 26.8577 23.2794 27.4286 22.831 27.8461C22.3826 28.2635 21.7936 28.4969 21.181 28.4999H14.101C13.4891 28.4964 12.901 28.263 12.4532 27.846C12.0055 27.429 11.7309 26.8589 11.684 26.2489L10.508 14.3709H10.068C9.65238 14.3709 9.25381 14.2058 8.95994 13.9119C8.66607 13.6181 8.50098 13.2195 8.50098 12.8039C8.50098 12.3883 8.66607 11.9897 8.95994 11.6959C9.25381 11.402 9.65238 11.2369 10.068 11.2369H13.816",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8179 11.2368H21.4779",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 14.3721H24.7857",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5968 11.157H13.6968V9.87898C13.6968 9.69785 13.7325 9.5185 13.8019 9.35118C13.8712 9.18386 13.9729 9.03186 14.1011 8.90388C14.2293 8.77589 14.3814 8.67443 14.5488 8.6053C14.7162 8.53616 14.8956 8.50072 15.0768 8.50098H20.2178C20.5832 8.50098 20.9337 8.64616 21.1922 8.90458C21.4506 9.16301 21.5958 9.51351 21.5958 9.87898L21.5968 11.157Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1924_6861",
    x1: 18.5,
    y1: 0,
    x2: 18.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF1F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1924_6861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1924_6861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.296,
    height: 21,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.a41705a62880fbee5b441a2719efab47.svg";
export { ForwardRef as ReactComponent };